import { Link, Navigate, useLocation } from "react-router-dom";
import { Info } from "lucide-react";
import { PublicHeader } from "@/components/PublicHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { useApp } from "@/context/AppContext";
import Registration from "@/pages/Registration";

const StaffNotice = () => (
  <div className="max-w-lg mx-auto bg-white border border-[#E5E7EB] rounded-lg p-6 shadow-sm" data-testid="staff-registration-notice">
    <div className="flex gap-3"><Info className="w-5 h-5 text-[#E60000] shrink-0 mt-0.5" />
      <div><h1 className="font-heading font-bold text-lg">Members register themselves</h1>
        <p className="text-sm text-gray-600 mt-1">Event registration is done by members from their own account. You are signed in with a staff account, so you can't register here.</p>
        <Link to="/event-registrations" className="inline-block mt-4 text-sm font-semibold text-[#E60000] hover:underline" data-testid="staff-registration-notice-link">Go to Event Registrations List</Link></div></div>
  </div>
);

export default function PublicRegistration() {
  const { auth, member } = useApp();
  const { pathname, search } = useLocation();
  const here = encodeURIComponent(pathname + search);
  if (auth === null) return <div className="min-h-screen grid place-items-center text-gray-500">Loading…</div>;
  if (auth?.kind === "staff") return <div className="min-h-screen bg-[#F8F9FA]"><PublicHeader /><main className="px-4 py-16"><StaffNotice /></main><SiteFooter /></div>;
  if (!member) return <Navigate to={`/login?next=${here}`} replace />;
  if (!member.email_verified) return <Navigate to={`/member/verify?next=${here}`} replace />;
  if (!member.profile_complete) return <Navigate to={`/my/profile?next=${here}`} replace />;
  return (
    <div className="min-h-screen bg-[#F8F9FA]" data-testid="public-registration-page">
      <PublicHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-8"><Registration lockedPin={member.pin} /></main>
      <SiteFooter />
    </div>
  );
}
